<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12" md="3">
        <label for>Search by centre name or mobile no</label>
        <input class="form-control" placeholder="Name" />
      </v-col>
      <v-col cols="12" md="3">
        <label for>Date Range</label>
        <datepicker
          v-model="joinOnDateRange"
          @input="dateChange()"
          ref="datepicker"
          :model-config="datePickerConfig"
          :max-date="new Date()"
          is-range
          :masks="{ input: 'DD/MM/YYYY' }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              :value="
                !!inputValue.start && !!inputValue.end
                  ? inputValue.start + ' - ' + inputValue.end
                  : 'DD/MM/YYYY'
              "
              v-on="inputEvents.start"
              class="form-control pos-r"
              placeholder="DD/MM/YYYY"
            />
            <div
              v-if="!!inputValue.start && !!inputValue.end"
              class="cross-svg"
              @click="resetJoiningDate"
            >
              <crossSVG />
            </div>
          </template>
        </datepicker>
        <div class="calendarsvg userinputcalendar pos-a">
          <calendarSVG />
        </div>
      </v-col>
      <CCol sm="12" md="2">
        <div class="position-relative">
          <label for>Role filter </label>
          <select name id class="form-control">
            <option value="Pharmacy">Pharmacy</option>
            <option value="Diagnostic">Diagnostic</option>
            <option value="Bloodbank">Bloodbank</option>
            <option value="Ambulance">Ambulance</option>
          </select>
          <span class="drop-icon">
            <i
              aria-hidden="true"
              class="v-icon mdi mdi-menu-down theme--light position-absolute"
            ></i>
          </span>
        </div>
      </CCol>
      <CCol sm="12" md="2">
        <div class="position-relative">
          <label for>Status</label>
          <select name id class="form-control">
            <option value="Paid">Paid</option>
            <option value="notPaid">Not paid</option>
          </select>
          <span class="drop-icon">
            <i
              aria-hidden="true"
              class="v-icon mdi mdi-menu-down theme--light position-absolute"
            ></i>
          </span>
        </div>
      </CCol>
      <CCol sm="12" md="2">
        <label class="col-sm-12 mb-0 d-none-mob1" for></label>
        <v-btn class="btn btn-primary mt-0">Export</v-btn>
      </CCol>
    </v-row>
    <!-- .................................. -->
    <v-row>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th>Centre name</th>
                <th>Owner name</th>
                <th>Mobile number</th>
                <th>Total Amount</th>
                <th>Number of orders</th>
                <th>Order details</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-capitalize">lorem ipsum</td>
                <td class="text-capitalize">lorem ipsum</td>
                <td>9836454743</td>
                <td>&#8377; 2000</td>
                <td>4</td>
                <td>
                  <a @click="orderDetails = true">View</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="orderDetails" scrollable width="900">
      <order-details @close="orderDetails = false" />
    </v-dialog>
  </div>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const orderDetails = () => import("@/views/payPerUse/modals/orderDetails");
export default {
  data() {
    return {
      orderDetails: false,
    };
  },
  components: {
    Datepicker,
    orderDetails,
  },
};
</script>
